import React from 'react';
import { Section } from './ui/Section';
export function Method3S() {
  return <Section id="metoda" background="white" className="text-center" data-id="element-117">
      <div className="max-w-4xl mx-auto mb-16" data-id="element-118">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-6" data-id="element-119">
          Metoda 3S: Știință · Suflet · Spirit
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-120">
          Procesul prin care îți armonizezi mintea, corpul și sufletul, ca să
          ieși din anxietate, frici și blocaje și să ajungi la liniște
          interioară, claritate și încredere.
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-121">
        {/* SVG Venn Diagram */}
        <div className="relative flex justify-center items-center min-h-[400px]" data-id="element-122">
          <svg viewBox="0 0 400 400" className="w-full max-w-md h-auto drop-shadow-xl" data-id="element-123">
            {/* Circle 1: Top Left - Science */}
            <circle cx="150" cy="150" r="100" fill="rgba(106, 90, 205, 0.2)" stroke="#6A5ACD" strokeWidth="2" data-id="element-124" />
            <text x="110" y="140" className="text-xs font-bold fill-brand-primary uppercase tracking-wider" data-id="element-125">
              Știință
            </text>

            {/* Circle 2: Top Right - Soul */}
            <circle cx="250" cy="150" r="100" fill="rgba(254, 197, 229, 0.3)" stroke="#FEC5E5" strokeWidth="2" data-id="element-126" />
            <text x="260" y="140" className="text-xs font-bold fill-brand-secondary-dark uppercase tracking-wider" data-id="element-127">
              Suflet
            </text>

            {/* Circle 3: Bottom - Spirit */}
            <circle cx="200" cy="240" r="100" fill="rgba(54, 130, 18, 0.1)" stroke="#368212" strokeWidth="2" data-id="element-128" />
            <text x="180" y="280" className="text-xs font-bold fill-brand-accent uppercase tracking-wider" data-id="element-129">
              Spirit
            </text>

            {/* Center Intersection */}
            <text x="200" y="190" textAnchor="middle" className="text-sm font-bold fill-brand-text font-serif" data-id="element-130">
              Armonie
            </text>
            <text x="200" y="205" textAnchor="middle" className="text-sm font-bold fill-brand-text font-serif" data-id="element-131">
              Interioară
            </text>
          </svg>
        </div>

        {/* Text Content */}
        <div className="space-y-8 text-left" data-id="element-132">
          <div className="flex gap-4" data-id="element-133">
            <div className="w-12 h-12 rounded-full bg-brand-primary/10 flex items-center justify-center flex-shrink-0 text-brand-primary font-bold text-xl" data-id="element-134">
              1
            </div>
            <div data-id="element-135">
              <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-136">
                ȘTIINȚĂ
              </h3>
              <p className="text-gray-600" data-id="element-137">
                Psihoterapie integrativă + Metoda Feuerstein (înțelegi și
                restructurezi tiparele care te conduc)
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-138">
            <div className="w-12 h-12 rounded-full bg-brand-secondary/30 flex items-center justify-center flex-shrink-0 text-brand-secondary-dark font-bold text-xl" data-id="element-139">
              2
            </div>
            <div data-id="element-140">
              <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-141">SUFLET</h3>
              <p className="text-gray-600" data-id="element-142">
                Procesare emoțională, introspecție, exerciții practice (îți
                recapeți identitatea și stabilitatea)
              </p>
            </div>
          </div>

          <div className="flex gap-4" data-id="element-143">
            <div className="w-12 h-12 rounded-full bg-brand-accent/10 flex items-center justify-center flex-shrink-0 text-brand-accent font-bold text-xl" data-id="element-144">
              3
            </div>
            <div data-id="element-145">
              <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-146">SPIRIT</h3>
              <p className="text-gray-600" data-id="element-147">
                Reconectare autentică, practici simple, credință trăită (înveți
                să te sprijini pe Dumnezeu, nu pe frică)
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}